import {Component, Input} from '@angular/core';

import {RatingQuestionType} from 'shared/models/questions/rating-question-type';
import {TranslatedText} from 'shared/models/translated-text';

@Component({
  selector: 'type-rating',
  templateUrl: './type-rating.component.html',
  styleUrls: ['./type-rating.component.css'],
})
export class TypeRatingComponent {

  @Input() public language: string;
  @Input() public data: RatingQuestionType;
  @Input() public inChains: Array<string>;
  @Input() public isSystemQuestion: boolean;
  @Input() public isChainSystemEditable: boolean = false;

  constructor() {
    this.data = new RatingQuestionType();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-rating/type-rating.component.ts